import { IonButton, IonCol, IonRow, IonSpinner } from '@ionic/react';
import { Link, useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import InputCard, { InputCardTypes } from '../../../components/inputField';
import { forgotPassword } from '../../../context/actions/user';
import { GlobalContext } from '../../../context/provider';
import Btn from '../../../components/Btn';
import {
  FORGOTPASSWORD,
  FORGOTPASSWORD_ERROR,
} from '../../../context/actions/types';
import AuthLayout from '../components/AuthLayout';
import { DeviceContext } from '../../../deviceType';
import { IoIosArrowBack } from 'react-icons/io';
import { FaKey } from 'react-icons/fa6';
import { RiLockPasswordFill } from 'react-icons/ri';
import ErrorToast from '../../../components/error_toast';

const ForgotPassword: React.FC = () => {
  const size = useContext<any>(DeviceContext);

  const { userState, userDispatch } = useContext<any>(GlobalContext);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState<boolean | undefined>(false);
  const [error, setError] = useState<{
    state: boolean;
    message: string | null;
  }>({
    state: false,
    message: null,
  });
  const [form, setForm] = useState<{ email: string }>({ email: '' });
  let input_props: InputCardTypes = {
    borders: false,
    type: 'email',
    placeholder: 'Enter Your Email',
    name: 'email',
    maxLength: 156,
    minLength: 1,
    clear: false,
    inputType: 'text-field',
    required: true,
    formValues: form,
    value: setForm,
  };
  const re =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

  useEffect(() => {
    if (userState?.forgotPassword) {
      const email = userState.forgotPassword?.email;
      setForm(email);
      userDispatch({ type: FORGOTPASSWORD, payload: null });
      history.push({
        pathname: '/verifypassword',
        state: form,
      });
    }
    if (userState?.forgotPasswordError) {
      setError({
        state: true,
        message: userState?.forgotPasswordError?.response?.data.message,
      });
      userDispatch({ type: FORGOTPASSWORD_ERROR, payload: null });
    }
  }, [userState?.forgotPassword, userState?.forgotPasswordError]);

  useEffect(() => {
    if (form?.email.trim().length > 0) {
      setActive(true);
    }
  }, [form]);
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await forgotPassword(form)(userDispatch);
    setLoading(false);
  };

  return (
    <AuthLayout>
      <ErrorToast
        message={error.message!}
        isOpen={error.state}
        position={'bottom'}
        type="error"
        onClose={() => {
          setError({ state: false, message: null });
        }}
      />
      <section className="w-full h-auto flex flex-col items-center justify-center md:px-[35%] px-6">
        <div className="w-[25dvw] md:w-[8dvw] h-auto aspect-square rounded-full bg-white flex  items-center justify-center mt-4 p-8 md:p-10 overflow-hidden">
          <RiLockPasswordFill size="100%" className="text-secondary" />
        </div>
        <div className="w-full flex flex-col items-center justify-center font-roboto text-primary mt-4 py-2 text-center">
          <h2 className="text-2xl md:text-3xl font-medium ">Forgot Password</h2>
          <p className="text-base font-light mt-2 ">
            No! worries, we'll send you reset instructions
          </p>
        </div>
        <div className="w-full flex  items-center justify-center mt-4">
          <InputCard {...input_props} />
        </div>

        <div className="w-full flex  items-center justify-center mt-4">
          <IonButton
            type="submit"
            onClick={handleSubmit}
            color="secondary"
            expand="block"
            fill="solid"
            className="w-full font-roboto text-base font-medium"
            disabled={!re.test(form.email) || loading}
          >
            {loading && <IonSpinner slot="end"></IonSpinner>}
            Submit
          </IonButton>
        </div>
        <div className="w-full flex  items-center justify-center my-4">
          <IonButton
            type="submit"
            color="primary"
            fill="clear"
            className="w-auto font-roboto text-base font-normal"
          >
            <Link to="/login" className="!text-primary !hover:text-secondary">
              Back to Login
            </Link>
          </IonButton>
        </div>
      </section>
    </AuthLayout>
  );
};
export default ForgotPassword;
